<app-header ></app-header>

<div class="container main-container"
     [ngStyle]="{ 'background-image': catalogueService.getProperty('imageBackground') ? 'url(' + catalogueService.getProperty('imageBackground') + ')' : 'none' }">

  <app-edition-panel *ngIf="loginService.isAuth()" [catalogueId]="eventData['id']" [hidesEditItem]="true"></app-edition-panel>

  <app-menu-tabs [filter]="'ONLY_BRANDS'"></app-menu-tabs>

  <div class="container-fluid counter" *ngIf="!this.show">
    {{ filteredCount }} {{ 'brands' | customTranslation:'MENU_TABS.BRANDS':translateService.currentLang | translate | lowercase }}
  </div>
  <div class="container-fluid counter" *ngIf="this.show">
    {{oneElement}} {{ 'brands' | customTranslation:'MENU_TABS.BRANDS':translateService.currentLang | translate | lowercase }}
  </div>

  <div class="container-fluid brands-letters" style="display: flex;">
    <div class="brands-letter" [style.backgroundColor]="getBorderColor(letter === active)" *ngFor="let letter of letters"  
        [ngClass]="{ 'brands-letter--no-active': active !== letter, 'brands-letter--active': active === letter  }" (click)="setActive(letter)">
      {{ letter === 'ALL' ? ('COMMON.ALL' | translate) : letter }}
    </div>
  </div>

  <div class="container-fluid brands-block">
    <div [ngClass]="{ '': activeName !== item, 'bold': activeName === item  }" 
      class="long-text-one-line pointer" *ngFor="let item of names | filterByLetter:active" (click)="showCard(item)">
      {{item}}
    </div>
  </div>


<app-card style="display: none;"></app-card>


<div class="container-fluid" style="margin-top: 45px;">
  <card-grid *ngIf="selectedView === 'grid'" [items]="items" [show]="show"></card-grid>
  <card-modern *ngIf="selectedView === 'modern'" [items]="items" [show]="show"></card-modern>
  <card-list *ngIf="selectedView === 'list'" [items]="items" [show]="show"></card-list>
</div>
    <loader-throbber *ngIf="loader.count > 0"></loader-throbber>

</div>

<!-- <app-card-detail  style="display: none;"></app-card-detail>
 -->
<app-footer ></app-footer>
